
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
//```import constants types
import {
    TEMPLATE_SEARCH_REQUEST,
    TEMPLATE_CREATE_REQUEST,
    TEMPLATE_UPDATE_REQUEST,
} from 'Redux/actionTypes';

import {
    templateSearchResult,
    templateCreateResult,
    templateUpdateResult,
} from 'Redux/actions';

import { endpoints } from 'Core/defaultValues';
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';

function* searchTemplates({ payload }) {
    try {
        let QUERY = `
            query searchTemplates ($conditions: [TemplateSearchInput], $sort: [enumTemplateSortField], $limit: Int, $offset: Int) {
                result: searchTemplates (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                        dealerId
                        moduleCode
                        language
                        html
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["language"],
                        terms: [payload],
                        exact: true
                    },
                    {
                        fields: ["moduleCode"],
                        terms: ["login-page"],
                        exact: true
                    }
                ],
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            const { items } = data.result
            yield put(templateSearchResult(items))
        }

    } catch (exc) {
        yield put(templateSearchResult([]))
        ExceptionManager(
            exc,
            "Modules/loginPage/main/.components/createEditTemplate/redux/saga",
            "searchTemplates",
            true
        )
    }
}

function* createTemplate({ payload }) {
    try {
        let QUERY = `
            mutation createTemplate ($name: String!, $dealerId: Int!, $moduleCode: String!, $language: enumLanguage!, $html: String!) {
                result: createTemplate (name: $name, dealerId: $dealerId, moduleCode: $moduleCode, language: $language, html: $html) {
                    id
                    name
                    dealerId
                    moduleCode
                    language
                    html
                }
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(templateCreateResult(data.result))
        }
    } catch (exc) {
        if (exc?.error.includes("The template with the name")) {
            yield put(templateCreateResult({ error: true }))
        } else {
            ExceptionManager(
                exc,
                "Modules/loginPage/main/.components/createEditTemplate/redux/saga",
                "createTemplate",
                true
            )
            yield put(templateCreateResult())
        }

    }
}

function* updateTemplate({ payload }) {
    try {
        let QUERY = `
            mutation updateTemplate ($id: Int!, $name: String!, $dealerId: Int!, $moduleCode: String!, $language: enumLanguage!, $html: String!) {
                result: updateTemplate (id: $id, name: $name, dealerId: $dealerId, moduleCode: $moduleCode, language: $language, html: $html) {
                    id
                    name
                    dealerId
                    moduleCode
                    language
                    html
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(templateUpdateResult(data.result))
        } else yield put(templateUpdateResult())

    } catch (exc) {
        if (exc?.error.includes("The template with the name")) {
            yield put(templateUpdateResult({ error: true }))
        } else {
            yield put(templateUpdateResult())
            ExceptionManager(
                exc,
                "Modules/loginPage/main/.components/createEditTemplate/redux/saga",
                "updateTemplate",
                true
            )
        }
    }
}

function* watchMethods() {
    yield takeEvery(TEMPLATE_SEARCH_REQUEST, searchTemplates);
    yield takeEvery(TEMPLATE_CREATE_REQUEST, createTemplate);
    yield takeEvery(TEMPLATE_UPDATE_REQUEST, updateTemplate);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}